webpackJsonp([5],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sweetalert = __webpack_require__(5);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _commonMessages = __webpack_require__(6);
	
	var _commonMessages2 = _interopRequireDefault(_commonMessages);
	
	var _commonQuestionWizard = __webpack_require__(17);
	
	var _commonQuestionWizard2 = _interopRequireDefault(_commonQuestionWizard);
	
	var _endpointsAccountChangeRequestService = __webpack_require__(18);
	
	var _endpointsAccountChangeRequestService2 = _interopRequireDefault(_endpointsAccountChangeRequestService);
	
	var _endpointsSportParticipationService = __webpack_require__(7);
	
	var _endpointsSportParticipationService2 = _interopRequireDefault(_endpointsSportParticipationService);
	
	var _AccountSettingsSection = __webpack_require__(174);
	
	var _AccountSettingsSection2 = _interopRequireDefault(_AccountSettingsSection);
	
	var _BasicInformationSection = __webpack_require__(22);
	
	var _BasicInformationSection2 = _interopRequireDefault(_BasicInformationSection);
	
	var _SportParticipationSection = __webpack_require__(175);
	
	var _SportParticipationSection2 = _interopRequireDefault(_SportParticipationSection);
	
	var _accountContactInformationFormHandler = __webpack_require__(28);
	
	var _accountContactInformationFormHandler2 = _interopRequireDefault(_accountContactInformationFormHandler);
	
	var _TermsAndConditionsSection = __webpack_require__(176);
	
	var _TermsAndConditionsSection2 = _interopRequireDefault(_TermsAndConditionsSection);
	
	var _commonUtils = __webpack_require__(3);
	
	var _endpointsUrls = __webpack_require__(9);
	
	var _accountSettingsWizard = undefined;
	
	function handleOnStepChanging(currentStep, newIndex) {
	    // Clean up if user went backward before
	    var newStep = (0, _jquery2['default'])(_accountSettingsWizard.steps[newIndex].target);
	
	    if (currentStep.index < newIndex) {
	        // To remove error styles
	        newStep.find('label.error').remove();
	        newStep.find('.error').removeClass("error");
	    }
	}
	
	function mapToModel() {
	    var accountForm = (0, _jquery2['default'])('#account-settings-form');
	    var basicInfoForm = (0, _jquery2['default'])('#basic-information-form');
	    var contactForm = (0, _jquery2['default'])('#contact-form');
	    var termsForm = (0, _jquery2['default'])('#terms-form');
	
	    return {
	        //account Settings
	        email: accountForm.find('[name=edit-email]').val(),
	        securityQuestionKey: accountForm.find('[name=securityQuestionKey]').val(),
	        securityAnswer: accountForm.find('[name=securityAnswer]').val(),
	        password: accountForm.find('[name=edit-password]').val(),
	        //Basic Settings
	        firstName: basicInfoForm.find('[name=firstName]').val(),
	        middleName: basicInfoForm.find('[name=middleName]').val(),
	        lastName: basicInfoForm.find('[name=lastName]').val(),
	        accountSubType: basicInfoForm.find('[name=accountSubType]:checked').val(),
	        ethnicityCodes: basicInfoForm.find('[name=ethnicityCodes]:checked').map(function (i, item) {
	            return (0, _jquery2['default'])(item).val();
	        }).toArray(),
	        genderCode: basicInfoForm.find('[name=genderCode]:checked').val(),
	        dateOfBirthString: (0, _commonUtils.toISODateString)(basicInfoForm.find('[name=dateOfBirthString]').val()),
	        graduationDateString: basicInfoForm.find('[name=graduationDateString]').val(),
	        enrollmentDateString: basicInfoForm.find('[name=enrollmentDateString]').val(),
	        parent1RelationType: basicInfoForm.find('[name=parent1RelationType]').val(),
	        parent1EducationType: basicInfoForm.find('[name=parent1EducationType]').val(),
	        parent2RelationType: basicInfoForm.find('[name=parent2RelationType]').val(),
	        parent2EducationType: basicInfoForm.find('[name=parent2EducationType]').val(),
	        //contact info
	        address1: contactForm.find('[name=address1]').val(),
	        address2: contactForm.find('[name=address2]').val(),
	        city: contactForm.find('[name=city]').val(),
	        countryCode: contactForm.find('[name=countryCode]').val(),
	        stateCode: contactForm.find('[name=stateCode]').val(),
	        postalCode: contactForm.find('[name=postalCode]').val(),
	        phone: contactForm.find('[name=phone]').val(),
	        alternatePhone: contactForm.find('[name=alternatePhone]').val(),
	        contactName: contactForm.find('[name=contactName]').val(),
	        contactPhone: contactForm.find('[name=contactPhone]').val(),
	        contactEmail: contactForm.find('[name=contactEmail]').val(),
	        studentLegalSignature: termsForm.find('[name=accept-bylaw]').is(':checked'),
	        parentLegalSignature: termsForm.find('[name=parental-consent]').is(':checked') ? true : null
	    };
	}
	
	function addSportParticipation() {
	    var sportCodes = (0, _jquery2['default'])('#sport-participation-form').find('[name="sportsParticipation"]');
	    var sports = sportCodes.map(function (i, item) {
	        return (0, _jquery2['default'])(item).val();
	    }).toArray();
	
	    var chainedResults = Promise.resolve(true);
	
	    _jquery2['default'].each(sports, function (i, sportCode) {
	        chainedResults = chainedResults.then(function () {
	            return _endpointsSportParticipationService2['default'].addSport(sportCode);
	        });
	    });
	
	    return chainedResults;
	}
	
	function handleFinish() {
	    //the code validation that happens on the first account settings page caches the StudentAccountChangeRequestDTO when it is valid
	    var model = (0, _jquery2['default'])('#account-settings-form').data('change-request');
	
	    model.studentDTO = mapToModel();
	
	    var performChange = _endpointsAccountChangeRequestService2['default'].performChange(model);
	
	    // for profile accounts, add the sports as sports participation after the account is created
	    if (model.changeRequestType === _endpointsAccountChangeRequestService.AccountChangeType.CREATE_PROFILE_ACCOUNT) {
	        performChange = performChange.then(function () {
	            return (0, _endpointsUrls.ensureValidCsrfToken)(true);
	        }).then(function () {
	            return addSportParticipation();
	        });
	    }
	    _accountSettingsWizard.toggleFinishButton(false);
	    /******************************** START: SSO login - post account creation *********************************/
	    // 2023_01_05: SSO application has implemented a CSRF protection attack, so we cannot submit hidden form
	    // to log in users after account creation automatically; users will need to enter the credentials
	    // through the SSO login page to log in after the account creation.
	    /*
	        // Submit SSO hidden form after student account creation to authenticate the user against the CAS server.
	        // On successful authentication, a SSO session cookie(TGT) is set on the browser.
	        // When user attempts to access NCAA College Basketball Academy application, CAS server will validate
	        // the SSO session cookie(TGT) available in the browser and grant access to the
	        // application without prompting the user to login.
	        performChange
	        .then(() => {
	            $('#username').val(model.studentDTO.email);
	            $('#password').val(model.studentDTO.password);
	            $('#sso_form').submit();
	        })
	        .catch(function(){
	            swal({
	                title: "Error",
	                text: `We were unable to complete your request. ${Messages.CONTACT_SUPPORT}`,
	                type: "error",
	                confirmButtonText: "Ok" });
	    
	            _accountSettingsWizard.toggleFinishButton(true);
	        });
	    */
	    performChange.then(function () {
	        window.location.href = window.logOutUrl;
	    })['catch'](function () {
	        (0, _sweetalert2['default'])({
	            title: "Error",
	            text: 'We were unable to complete your request. ' + _commonMessages2['default'].CONTACT_SUPPORT,
	            type: "error",
	            confirmButtonText: "Ok" });
	
	        _accountSettingsWizard.toggleFinishButton(true);
	    });
	    /******************************** END: SSO login - post account creation *********************************/
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	
	    var containerSelector = '#account';
	
	    _accountSettingsWizard = new _commonQuestionWizard2['default']({
	        selector: containerSelector,
	        stepValidation: {
	            'accountsettings': _AccountSettingsSection2['default'].validate,
	            'basicinformation': _BasicInformationSection2['default'].validate,
	            'contact': _accountContactInformationFormHandler2['default'].validate,
	            'sportsparticipation': _SportParticipationSection2['default'].validate,
	            'terms': _TermsAndConditionsSection2['default'].validate
	        }
	    });
	
	    //attach event handler
	    _accountSettingsWizard.addListener('StepChanging', handleOnStepChanging);
	    _accountSettingsWizard.addListener('Finish', handleFinish);
	
	    //usability Set focus on the first form element when the tab is shown
	    _accountSettingsWizard.addListener('StepChanged', function (e) {
	        (0, _jquery2['default'])(e.current.target).find('input, select').filter(':first').trigger('focus');
	    });
	
	    _AccountSettingsSection2['default'].wireup();
	    _BasicInformationSection2['default'].wireup();
	    _accountContactInformationFormHandler2['default'].wireup();
	    _SportParticipationSection2['default'].wireup();
	    _TermsAndConditionsSection2['default'].wireup();
	
	    _BasicInformationSection.eventBus.addListener(_BasicInformationSection.Events.DOB_CHANGED, _TermsAndConditionsSection2['default'].handleDateOfBirthChange);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _fbemitter = __webpack_require__(10);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _endpointsAccountChangeRequestService = __webpack_require__(18);
	
	var _commonValidators = __webpack_require__(13);
	
	var _commonUtils = __webpack_require__(3);
	
	var FORM_SELECTOR = '#account-settings-form';
	
	/**
	 * Shows wizard navigation steps that are only present for profile accounts
	 * Also shows the disabled links for Schools, Sports, and payment
	 */
	function cleanUpSteps(wizard, changeRequest) {
	
	    if (changeRequest.changeRequestType === _endpointsAccountChangeRequestService.AccountChangeType.CREATE_ACCOUNT) {
	        //show the side nav links for the account pages that will be
	        //filled out after they create their account
	        (0, _jquery2['default'])('#sidebar li.hidden').removeClass('hidden');
	    }
	
	    if (changeRequest.changeRequestType === _endpointsAccountChangeRequestService.AccountChangeType.CREATE_PROFILE_ACCOUNT) {
	        //show the sports wizard step
	        (0, _jquery2['default'])('.wizard-steps a.disabled').removeClass('disabled').closest('li').removeClass('hidden');
	    }
	
	    wizard.reloadSteps();
	}
	
	exports['default'] = {
	    wireup: function wireup() {
	
	        _commonValidators.securityCode.addMethod();
	
	        var theForm = (0, _jquery2['default'])(FORM_SELECTOR);
	        theForm.validate({
	            rules: {
	                'edit-password-confirm': {
	                    'equalTo': '#edit-password'
	                }
	            },
	            messages: {
	                'edit-password-confirm': {
	                    'equalTo': 'passwords must match'
	                }
	            }
	        });
	
	        // trigger the validation message for edit-password to always display the password requirement
	        (0, _commonUtils.showValidationMessageForElement)(FORM_SELECTOR, 'edit-password', 'passwordNCAA');
	    },
	    validate: function validate(wizard) {
	
	        var theForm = (0, _jquery2['default'])(FORM_SELECTOR);
	        var isValid = theForm.valid();
	        var changeRequest = theForm.data('change-request');
	
	        if (isValid === true) {
	            cleanUpSteps(wizard, changeRequest);
	        }
	
	        return new Promise(function (resolve) {
	            resolve(isValid);
	        });
	    }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var FORM_SELECTOR = '#sport-participation-form';
	
	exports['default'] = {
	    wireup: function wireup() {
	
	        var theForm = (0, _jquery2['default'])(FORM_SELECTOR);
	        theForm.validate();
	
	        theForm.find('.selectize').selectize({
	            create: false,
	            openOnFocus: true,
	            closeAfterSelect: false,
	            selectOnTab: true
	        });
	    },
	    validate: function validate() {
	
	        var isValid = (0, _jquery2['default'])(FORM_SELECTOR).valid();
	
	        return new Promise(function (resolve) {
	            resolve(isValid);
	        });
	    }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _commonUtils = __webpack_require__(3);
	
	var FORM_SELECTOR = '#terms-form';
	
	exports['default'] = {
	    wireup: function wireup() {
	
	        var theForm = (0, _jquery2['default'])(FORM_SELECTOR);
	        theForm.validate();
	
	        //the signature line should only be enabled if user accepts all terms
	        theForm.on('change', ':checkbox', function () {
	            var allChecked = theForm.find('#accept-terms, #accept-bylaw').filter(':not(:checked)').length === 0;
	
	            theForm.find('#fullName').prop('disabled', !allChecked);
	        });
	    },
	    validate: function validate() {
	
	        var isValid = (0, _jquery2['default'])(FORM_SELECTOR).valid();
	
	        return new Promise(function (resolve) {
	            resolve(isValid);
	        });
	    },
	    handleDateOfBirthChange: function handleDateOfBirthChange(dateOfBirth) {
	        var dob = (0, _commonUtils.convertDateStringToDate)(dateOfBirth);
	        var now = (0, _moment2['default'])();
	
	        // display the parental consent if the student is under 18 years old
	        (0, _jquery2['default'])(FORM_SELECTOR).find('.js-parental-consent').toggleClass('collapse', now.diff(dob, 'years') > 17);
	    }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ })

});


// WEBPACK FOOTER //
// complete-registration-page.js